/*
 * a标签组件，用于支持鼠标右键能打开新链接
 */
import React from 'react';
import classNames from 'classnames';
import './index.scss';

// 组件基本类型
export interface BaseComponentProps extends React.PropsWithChildren {
  // 组件自定义类名
  className?: string;
  // 组件自定义样式
  style?: React.CSSProperties;
}

interface IACardProps extends BaseComponentProps {
  // 跳转链接
  url?: string;
  isStopPropagation?: boolean;
}

const ALinkCard = (props: IACardProps) => {
  const { style, className, url, isStopPropagation = true, children } = props;

  if (typeof url !== 'string') {
    return children;
  }

  return url ? (
    <a
      className={classNames('dbg-alink-card-container', className)}
      style={style}
      href={url}
      onClick={(e) => {
        // 阻止a标签默认跳转和事件冒泡
        e.preventDefault();
        isStopPropagation && e.stopPropagation();
      }}
    >
      {children}
    </a>
  ) : (
    children
  );
};

export default ALinkCard;
